<div class="choosePhoto_container">
            <h4 class="title_head photo_head">Upload photo</h4>
    <div class="photos_container edit-image">

        <div class="camera" (click)="openDialog()"><img src="../../../assets/images/camera_rent_page.svg" alt="">

        </div>
        <div class="gallery file-upload">
            <img src="../../../assets/images/photo_icon_rent-page.svg" alt="">
            <input type="file" (change)="onFileSelected($event)" id="upload-image-btn">

        </div>
    </div>

    <div class="names"><div class="cam">Camera</div><div class="cam">Files</div></div>

    <div class="file_chosen" *ngIf="fileName"><span class="file_head">File Name : </span><span class="file_name">{{
            fileName }}</span></div>
</div>

<div mat-dialog-actions style="display: flex;justify-content: flex-end;">
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-button cdkFocusInitial (click)="onSubmit()">Save</button>
</div>